// @flow
import * as React from "react"
import "./styles.scss"
import {
    Heading,
    TextField,
    Label,
    Stack,
    Button,
    Scrollable,
    Checkbox,
    TextStyle,
} from "@shopify/polaris"
import Switch from "react-switch"
import "./rc-color-picker.min.css"
import ColorSettings from "../ColorSettings"
const ColorPicker = require("rc-color-picker")
const Color = require("color")
// const rgbHex = require('rgb-hex');
// const hexRgb = require('hex-rgb');

type Props = {
    iconList: Array<Object>,
    setting: Object,
    iconKey: String,
    settingType: String,
    iconType: String,
    updateIcon: (setting_type: String, icon_type: String, updateObj: Object) => void,
}

type State = {}

var delay = null

export default class IconList extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props)
    }
    state = {
        customIcon: false,
        checkCustom: false,
        path: "",
        viewBox: "0 0 0 0",
        contentFile: "",
    }

    changeIcon(target, value) {
        const { iconList, settingType, iconType, updateIcon } = this.props
        let selectedIcon = iconList.find((icon) => icon.id === value)
        // Remove fill and strok property
        let match = selectedIcon.path.match(
            new RegExp(`fill=(?:\'|\")(?:(?!\'|\")\\S)+(?:\'|\")`, "gm"),
        )
        let match2 = selectedIcon.path.match(
            new RegExp(`stroke=(?:\'|\")(?:(?!\'|\")\\S)+(?:\'|\")`, "gm"),
        )

        let replacedPath = selectedIcon.path
        if (match) {
            for (let i = 0; i < match.length; i++) {
                replacedPath = replacedPath.replace(match[i], "")
            }
        }
        if (match2) {
            for (let i = 0; i < match2.length; i++) {
                replacedPath = replacedPath.replace(match2[i], "")
            }
        }

        if (match || match2) {
            //let _match  = match[0].split('=');
            updateIcon(settingType, iconType, {
                icon_id: selectedIcon.id,
                svg: replacedPath,
                view_box: selectedIcon.viewBox,
                width: selectedIcon.width,
                height: selectedIcon.height,
            })
        }
        this.setState({ checkCustom: false })
    }
    openFileDialog(accept, multy = false, callback) {
        var inputElement = document.createElement("input")
        inputElement.type = "file"
        inputElement.accept = accept // Note Edge does not support this attribute
        if (multy) {
            inputElement.multiple = multy
        }
        if (typeof callback === "function") {
            inputElement.addEventListener("change", callback)
        }
        // const inputElement = document.getElementById('file-upload');
        inputElement.dispatchEvent(new MouseEvent("click"))
    }

    handleUploadIcon = () => {
        this.openFileDialog(".svg", true, this.fileDialogChanged.bind(this))
    }

    // file dialog onchange event handler
    fileDialogChanged(e) {
        var file = e.target.files[0]
        if (!file) {
            return
        }
        var reader = new FileReader()
        var contents = ""
        reader.onload = (e) => {
            contents = e.target.result
            this.loadSvg(contents)
        }
        reader.readAsText(file)
    }

    loadSvg = (contents) => {
        const { iconList, settingType, iconType, updateIcon } = this.props
        let width = 26
        let height = 26
        let indexViewBox = contents.indexOf("viewBox")
        let indexPath = contents.indexOf("<path")
        let lastIndexPath = contents.indexOf("</g>")
        let textPath, textViewBox
        if (indexViewBox) {
            let text = contents.slice(indexViewBox + 9)
            let lastIndexViewBox = text.indexOf('" ')
            textViewBox = text.slice(0, lastIndexViewBox)
        }
        if (indexPath && lastIndexPath) {
            textPath = contents.slice(indexPath, lastIndexPath)
        }
        this.setState({
            path: textPath,
            viewBox: textViewBox,
            checkCustom: true,
            contentFile: contents,
        })
        updateIcon(settingType, iconType, {
            icon_id: 10,
            svg: textPath,
            view_box: textViewBox,
            width,
            height,
        })
    }

    handleChangeText = (val) => {
        this.setState({ contentFile: val.trim() })
        setTimeout(() => {
            this.loadSvg(this.state.contentFile)
        }, 200)
    }

    showCustomSvg = () => {
        const { setting, iconKey, updateIcon, settingType, iconType } = this.props
        const { path, viewBox, checkCustom } = this.state
        let width = 26
        let height = 26
        const svgString2 = `<svg width="26px" height="26px" class="arn_icon ${iconKey}"><use xlink:href="#${iconKey}"></use></svg>`
        return (
            <div className={checkCustom ? "icon-item selected" : "icon-item"}>
                <input
                    className="radio-btn"
                    type="radio"
                    name="app-icon"
                    value="9"
                    onClick={(e) => {
                        updateIcon(settingType, iconType, {
                            icon_id: 10,
                            svg: path,
                            view_box: viewBox,
                            width,
                            height,
                        })
                        this.setState({ checkCustom: true })
                    }}
                />
                <p className="visual-preview">
                    <svg
                        width="26px"
                        height="26px"
                        aria-hidden="true"
                        focusable="false"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox={viewBox}
                        dangerouslySetInnerHTML={{
                            __html: path,
                        }}
                    ></svg>
                </p>
            </div>
        )
    }

    handleChangeColorNormal(colorVal) {
        const { settingType, iconType } = this.props
        this.props.updateIcon(settingType, iconType, {
            icon_color: colorVal,
        })
    }

    handleChangeColorAcive(colorVal) {
        const { settingType, iconType } = this.props
        this.props.updateIcon(settingType, iconType, {
            icon_active_color: colorVal,
        })
    }

    render() {
        const { iconList, setting, iconKey, updateIcon, settingType, iconType } = this.props
        const { path, viewBox, customIcon, contentFile } = this.state
        let selectedIcon = {}
        const iconListTpl = iconList.map((icon, index) => {
            const svgString = `<svg width="${icon.width}" height="${icon.height}" class="arn_icon ${iconKey}"><use xlink:href="#${iconKey}-${index}"></use></svg>`
            const selectedClass = icon.id === setting.icon_id ? " selected" : ""
            if (icon.id === setting.icon_id) {
                selectedIcon = icon
            }
            return (
                <div key={index} className={"icon-item" + selectedClass}>
                    <input
                        className="radio-btn"
                        type="radio"
                        name="app-icon"
                        value={icon.id}
                        onChange={(e) => {
                            this.changeIcon(e.target, e.target.value)
                        }}
                    />
                    <p
                        className="visual-preview"
                        dangerouslySetInnerHTML={{ __html: svgString }}
                    ></p>
                </div>
            )
        })

        const symbolSvg = iconList.map((icon, index) => {
            return (
                <symbol key={index} id={`${iconKey}-${index}`} viewBox={icon.viewBox}>
                    <g dangerouslySetInnerHTML={{ __html: icon.path }}></g>
                </symbol>
            )
        })

        return (
            <div className="predefined-icons--wrapper clearfix mt-10">
                {/* <Heading>Predefined Icons</Heading> */}
                <Stack distribution="equalSpacing">
                    <Checkbox
                        checked={customIcon}
                        onChange={() => {
                            this.setState({ customIcon: !customIcon })
                        }}
                        label="Custom"
                    />
                    {customIcon ? (
                        <Button size="slim" onClick={() => this.handleUploadIcon()}>
                            Upload File
                        </Button>
                    ) : (
                        ""
                    )}
                </Stack>

                {/* <Switch height={20} width={46} /> */}
                {!customIcon ? (
                    <div className="mt-10">
                        <Stack distribution="equalSpacing" alignment="center">
                            <TextStyle>
                                Select your icon loading bellow or upload your SVG icon
                            </TextStyle>
                            <div className="pre-icon">
                                <svg
                                    xmlnsXlink="http://www.w3.org/2000/svg"
                                    style={{ display: "none" }}
                                >
                                    {symbolSvg}
                                </svg>
                                <div className="icon-list clearfix">{iconListTpl}</div>
                            </div>
                        </Stack>
                    </div>
                ) : (
                    <div className="mt-10">
                        {path && (
                            <div className="mt-10">
                                <div className="icon-list clearfix">{this.showCustomSvg()}</div>

                                <div>
                                    <Scrollable shadow style={{ height: "250px" }}>
                                        <TextField
                                            multiline={1}
                                            value={contentFile}
                                            onChange={(val) => this.handleChangeText(val)}
                                        />
                                    </Scrollable>
                                </div>
                            </div>
                        )}
                    </div>
                )}
                {iconType !== "preloader_icon" ? (
                    <div className="row-item-wh">
                        <div className="icon-wh">
                            <TextField
                                label="Icon Width"
                                value={String(setting.width)}
                                type="number"
                                min={10}
                                max={26}
                                onChange={(val) => {
                                    this.props.updateIcon(settingType, iconType, {
                                        width: Number(val),
                                    })
                                }}
                            />
                        </div>
                        <div className="icon-wh">
                            <TextField
                                label="Icon Height"
                                value={String(setting.height)}
                                type="number"
                                min={10}
                                max={26}
                                onChange={(val) => {
                                    this.props.updateIcon(settingType, iconType, {
                                        height: Number(val),
                                    })
                                }}
                            />
                        </div>
                    </div>
                ) : null}
                <div className="row-item">
                    {/* <Label>Icon Color</Label> */}
                    <div className="pickers-wrapper">
                        <div className="row-item-wh">
                            <ColorSettings
                                general={this.props.general}
                                text={this.props.general ? "Loading icon color" : "Normal Color"}
                                color={setting.icon_color}
                                changeColor={(val) => this.handleChangeColorNormal(val)}
                            />
                            {setting.icon_active_color && (
                                <ColorSettings
                                    text="Active Color"
                                    color={setting.icon_active_color}
                                    changeColor={(val) => this.handleChangeColorAcive(val)}
                                />
                            )}
                        </div>
                        {/* <ColorPicker
                            className="default"
                            color={setting.icon_color}
                            enableAlpha={false}
                            align={{
                                points: ["tl", "tr"],
                                offset: [0, 0],
                                targetOffset: ["0%", "200%"],
                                overflow: { adjustX: true, adjustY: true },
                            }}
                            onClose={(color) => {
                                let colorVal = color.color
                                this.props.updateIcon(settingType, iconType, {
                                    icon_color: colorVal,
                                })
                            }}
                        /> */}
                        {/* <ColorPicker
                            className="active"
                            color={setting.icon_active_color}
                            enableAlpha={false}
                            align={{
                                points: ["tl", "tr"],
                                offset: [0, 0],
                                targetOffset: ["0%", "200%"],
                                overflow: { adjustX: true, adjustY: true },
                            }}
                            onClose={(color) => {
                                let colorVal = color.color
                                this.props.updateIcon(settingType, iconType, {
                                    icon_active_color: colorVal,
                                })
                            }}
                        /> */}
                        {/* {iconType === "add_class_icon" ? (

            ) : null} */}
                    </div>
                </div>
            </div>
        )
    }
}

{
    /* <ColorPicker
    className={`${item.setting_type}__${item.icon_type}__${item.key_type}`}
    color={item.key_value}
    align={
    {
        points: ['tl', 'tr'],
        offset: [0, 0],
        targetOffset: ['0%','200%'],
        overflow: { adjustX: true, adjustY: true },
    }}
    onClose={this.closeColorPanel.bind(this, other, `${item.setting_type}__${item.icon_type}__${item.key_type}`)}

/> */
}
